import { useAuth } from "@/utils/auth";

import Banner from "@/components/common/Banner";
import { Button } from "@/components/ui/button";
import useHome from "@/hooks/useHome";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import useNavigateOnboardingOrProfile from "../../onboarding/hooks/useNavigateOnboardingOrProfile";
function LoggedInBanner() {
	const navigateNext = useNavigateOnboardingOrProfile();
	const [showBanner, setShowBanner] = useState(false);
	const auth = useAuth();
	const home = useHome();

	useEffect(() => {
		if (auth.isAuthenticated) {
			setShowBanner(true);
		}
	}, [auth.isAuthenticated]);

	if (!auth.isAuthenticated) return null;

	return (
		<Banner
			show={showBanner}
			setShow={setShowBanner}
			className={cn("bg-violet-300", auth.isAuthenticated ? "h-fit" : "h-0")}
		>
			<div className="flex flex-row items-center gap-2 min-w-[200px]">
				<p
					className={cn(
						auth.isAuthenticated
							? "flex flex-row gap-2 text-nowrap text-md"
							: "hidden",
					)}
				>
					You are logged in.
				</p>
				<Button
					className="inline-block px-0 py-0 h-8"
					variant="link"
					onClick={navigateNext}
				>
					Go to {home?.label}
				</Button>
			</div>
		</Banner>
	);
}

export default LoggedInBanner;
